import { WalletPreview } from "@/components/WalletPreview"
import { SegmentedControl } from "@/kit/antipad-ui/SegmentedControl"
import { GridTitleItem } from "../GridTitleItem"
import { AI_PICKS, POPULAR_ADDRESSES, RECENT_COPIES } from "@/constants/addresses"
import { Flex as FlexKit } from "@/kit/antipad-ui/Flex"
import styles from './styles.module.css'
import { useState } from "react"


export const WalletsMobile = () => {
    const [selectedTab, setSelectedTab] = useState('popular')
    return <div>



        <div className={styles.well}>

            <div style={{ marginBottom: '15px' }}>
                <SegmentedControl onChange={(value) => setSelectedTab(value as any)} values={[{ id: 'popular', label: 'Popular' }, { id: 'recent', label: 'Recent' }, { id: 'profitable', label: 'Profitable' }]} value={selectedTab} />
            </div>
            {selectedTab === 'popular' && <FlexKit direction="column" style={{ gap: '15px' }} fullWidth>
                {/* <GridTitleItem title='Popular Wallets' icon='fire' /> */}
                {POPULAR_ADDRESSES.map((address) => (
                    <WalletPreview adress={address} />
                ))}
            </FlexKit>}

            {selectedTab === 'recent' && <FlexKit direction="column" style={{ gap: '15px' }}>
                {/* <GridTitleItem title='Recent Copies' icon='star' /> */}
                {RECENT_COPIES.map((address) => (
                    <WalletPreview adress={address} />
                ))}
            </FlexKit>}

            {selectedTab === 'profitable' && <FlexKit direction="column" style={{ gap: '15px' }}>
                {/* <GridTitleItem title='Most Profitable' icon='flash' /> */}
                {AI_PICKS.map((address) => (
                    <WalletPreview adress={address} />
                ))}
            </FlexKit>}
        </div>
    </div>
}